import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useStores } from '@/store'
import moment from 'moment'
import { Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'
import { Loading } from '@/components'
import { isMobile } from '@/service/utils'
const officialPageSize = isMobile() ? 4 : 6
const othersPageSize = isMobile() ? 6 : 12
// const onceLoadNum = isMobile() ? 4 : 6
const rowNumber = isMobile() ? 2 : 6
const imgHeight = 160
const photosSize = 20

let loading = false

export const Gallery = ({ restaurant, hideGallery, openReview }) => {
  const [photos, setPhotos] = useState([])
  const [pictures, setPictures] = useState([])
  const [activePhotoIndex, setActivePhotoIndex] = useState(0)
  const [show, setShow] = useState(false)
  // 控制显示官方或其他全部图片
  const [isAllPhotos, setIsAllPhotos] = useState(false)
  // 官方图片的分页信息
  const [officialPageInfo, setOfficialPageInfo] = useState({})
  // 其他图片的分页信息
  const [othersPageInfo, setOthersPageInfo] = useState({})
  // 当前全屏显示的图片类型
  const [showFullType, setShowFullType] = useState('')
  // 保存当前查看全部图片的图片列表
  const [allPhotoList, setAllPhotoList] = useState([])
  const [galleryTitle, setGalleryTitle] = useState('')
  const { t } = useTranslation()
  const { restaurantStore } = useStores()
  const loadedRef = useRef(0)
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    // 其他
    restaurantStore.getImgs('photos', 1, othersPageSize).then(res => {
      const { data, headers } = res
      setOthersPageInfo({
        total: headers['total_count'],
        totalPages: headers['total_pages'],
        current: headers['current_page'],
        nextPage: headers['next_page']
      })
      const fillLength = rowNumber - (data.length % rowNumber)
      if (fillLength < rowNumber) {
        data.push(...new Array(fillLength).fill({ isEmpty: true }))
      }
      setPhotos(data)
    })
    // 官方
    restaurantStore.getImgs('pictures', 1, officialPageSize).then(res => {
      const { data, headers } = res
      setOfficialPageInfo({
        total: headers['total_count'],
        totalPages: headers['total_pages'],
        current: headers['current_page'],
        nextPage: headers['next_page']
      })
      const fillLength = rowNumber - (data.length % rowNumber)

      if (fillLength < rowNumber) {
        data.push(...new Array(fillLength).fill({ isEmpty: true }))
      }
      setPictures(data.map(_ => ({ ..._, image_url: _.picture_url })))
    })
  }, [])
  const handleClick = async (type, item, index) => {
    if (!item.picture_url && !item.image_url) return
    setActivePhotoIndex(index)
    if (isAllPhotos) {
      setGalleryTitle(t('BOOKING.All'))
    } else {
      setGalleryTitle(type === 'official' ? t('WEB.Official photos') : t('WEB.Others posted'))
    }
    setShowFullType(type)
    setShow(true)
  }
  const handleMore = async type => {
    loadedRef.current = 0
    setAllPhotoList([])
    setShowFullType(type)
    setIsAllPhotos(true)
    setHasMore(true)
    await getPic(1, type)
  }
  const titleText = useMemo(() => {
    if (isAllPhotos) {
      return showFullType === 'official' ? t('WEB.Official photos') : t('WEB.Others posted')
    }
    return t('WEB.Gallery')
  }, [isAllPhotos, showFullType])

  async function getPic(page = 1, type) {
    if (loading) return
    loading = true
    // 动态获取占满一屏需要多少张图片
    const count = Math.ceil(window.innerHeight / imgHeight) * rowNumber
    restaurantStore.getImgs(type === 'official' ? 'pictures' : 'photos', page, count).then(res => {
      const { data = [], headers } = res

      if (data) {
        let totalRes = []
        if (page === 1) {
          totalRes = data
        } else {
          totalRes = allPhotoList.concat(data)
        }
        const fillLength = rowNumber - (totalRes.length % rowNumber)
        if (fillLength < rowNumber) {
          const arr = new Array(fillLength).fill({ isEmpty: true })
          totalRes = totalRes.concat(arr)
        }
        setAllPhotoList(totalRes)
        if (parseInt(headers['next_page']) === 1) {
          setHasMore(false)
        }
        loading = false
      }
    })
  }

  function loadMore(page) {
    if (loading || !hasMore) return false
    getPic(page, showFullType)
  }

  return (
    <div className='page-gallery'>
      <div className='navigation-title' style={{ marginTop: '-5px' }}>
        <div onClick={() => hideGallery(false)}>{restaurant?.name}</div>
        <span>&gt;</span>
        <div className={isAllPhotos ? '' : 'navigation-title-selected'} onClick={() => setIsAllPhotos(false)}>
          {t('WEB.Gallery')}
        </div>
        {isAllPhotos && (
          <React.Fragment>
            <span>&gt;</span>
            <div className='navigation-title-selected'>
              {showFullType === 'official' ? t('WEB.Official photos') : t('WEB.Others posted')}
            </div>
          </React.Fragment>
        )}
      </div>
      {isMobile() && (
        <div className='gallery-header-mobile'>
          <span>{isAllPhotos && <i onClick={() => setIsAllPhotos(false)} className='icon icon-arrow-left'></i>}</span>
          <span>{titleText}</span>
          <span>
            <i onClick={() => hideGallery(false)} className='icon gallery-close'></i>
          </span>
        </div>
      )}
      <div className={isAllPhotos ? 'gallery-container scroll-container' : 'gallery-container'}>
        {!isAllPhotos && (
          <React.Fragment>
            {pictures.length > 0 && (
              <div className='officialPhotos'>
                {pictures.map((item, index) => (
                  <div className='photo-item' key={index} onClick={() => handleClick('official', item, index)}>
                    {!item?.isEmpty && (
                      <React.Fragment>
                        <i className='icon icon-official-tag'></i>
                        <img src={item.picture_url} alt='' />
                        <Skeleton.Image className='skeleton-img' active={true} />
                      </React.Fragment>
                    )}
                  </div>
                ))}
                <div className='official-more'>
                  <span onClick={() => handleMore('official')}>{t('WEB.View all official photos')} &gt;</span>
                </div>
                <div className='hairline-bottom-new'></div>
              </div>
            )}
            {photos.length > 0 && (
              <div className='othersPhotos'>
                {photos.map((item, index) => (
                  <div className='photo-item' key={index} onClick={() => handleClick('other', item, index)}>
                    {!item?.isEmpty && (
                      <React.Fragment>
                        <img src={item.image_url} alt='' />
                        <Skeleton.Image className='skeleton-img' active={true} />
                      </React.Fragment>
                    )}
                  </div>
                ))}
                <div className='other-more'>
                  <span onClick={() => handleMore('other')}>{t('WEB.View all Others posted')} &gt;</span>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        {isAllPhotos && (
          <div className='officialPhotos allPhotos'>
            <InfiniteScroll
              className='photosScroll'
              initialLoad={false}
              pageStart={1}
              loadMore={loadMore}
              hasMore={hasMore}
              useWindow={false}
            >
              {allPhotoList.map((item, index) => (
                <div className='photo-item' key={index} onClick={() => handleClick(showFullType, item, index)}>
                  {!item?.isEmpty && (
                    <React.Fragment>
                      {showFullType === 'official' && <i className='icon icon-official-tag'></i>}
                      <img src={item?.picture_url || item?.image_url} alt='' />
                      <Skeleton.Image className='skeleton-img' active={true} />
                    </React.Fragment>
                  )}
                </div>
              ))}
              <div className='load-more'>{hasMore && <Loading red></Loading>}</div>
            </InfiniteScroll>
          </div>
        )}
      </div>
      {show && (
        <PhotoViewer
          key={allPhotoList.length}
          activePhotoIndex={activePhotoIndex}
          pageInfo={showFullType === 'official' ? officialPageInfo : othersPageInfo}
          type={showFullType}
          hideGallery={hideGallery}
          onClose={() => setShow(false)}
          title={galleryTitle}
          openReview={openReview}
        />
      )}
    </div>
  )
}

const PhotoViewer = ({ activePhotoIndex, pageInfo, type, hideGallery, onClose, title, openReview }) => {
  const [curIndex, setCurIndex] = useState(activePhotoIndex)
  const [showCollapse, setShowCollapse] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [tagPos, setTagPos] = useState({})
  const [curImg, setCurImg] = useState({})
  const eleRef = useRef(null)
  const photosCache = useRef(Array(parseInt(pageInfo.total)))

  const { t } = useTranslation()
  const { restaurantStore } = useStores()
  useEffect(() => {
    setShowCollapse(eleRef?.current?.scrollWidth > eleRef?.current?.clientWidth)
    setLoading(true)
    if (photosCache.current[curIndex]) {
      setCurImg(photosCache.current[curIndex])
      return
    }
    // 计算当前图片位于第几页
    const page = curIndex < 20 ? 1 : Math.ceil((curIndex + 1) / photosSize)
    restaurantStore.getImgs(type === 'official' ? 'pictures' : 'photos', page, photosSize).then(res => {
      const { data } = res
      photosCache.current.splice((page - 1) * photosSize, photosSize, ...data)
      setCurImg(photosCache.current[curIndex])
    })
  }, [curIndex])
  const handleLoad = event => {
    setLoading(false)
    setTagPos({
      x: event.target.offsetLeft - 2,
      y: event.target.offsetTop - 2
    })
  }
  const prevPhoto = () => {
    if (curIndex <= 0) {
      // if (!photos[photos.length - 1]) return
      setCurIndex(pageInfo.total - 1)
    } else {
      setCurIndex(curIndex - 1)
    }
  }
  const nextPhoto = () => {
    if (curIndex >= pageInfo.total - 1) {
      setCurIndex(0)
    } else {
      // if (!photos[curIndex + 1]) return
      setCurIndex(curIndex + 1)
    }
  }
  const togglePanel = () => {
    setIsOpen(!isOpen)
  }
  const toViewDetail = item => {
    if (item?.review_id) {
      restaurantStore.getReview(item?.review_id).then(res => {
        hideGallery(false)
        openReview(res)
      })
    }
  }

  return (
    <div className='photo-viewer'>
      <div className='restaurant-gallery-modal'>
        <div className='restaurant-gallery-modal--overlay'>
          <div className='restaurant-gallery-modal--content'>
            <p className='photoTotal'>
              <strong>{title}</strong>
              <span>
                ({curIndex + 1}/{pageInfo.total})
              </span>
            </p>
            <div className='restaurant-gallery-modal--close'>
              <button className='restaurant-gallery-close' type='button' onClick={onClose}>
                <i onClick={nextPhoto} className='icon gallery-close'></i>
              </button>
            </div>
            <div className='restaurant-gallery-content'>
              <div className='restaurant-gallery'>
                <div className='restaurant-gallery-main'>
                  <button
                    disabled={loading}
                    type='button'
                    className='restaurant-gallery-control restaurant-gallery-control--prev'
                    onClick={prevPhoto}
                  >
                    <i className='icon icon-arrow-left'></i>
                  </button>
                  <div className='restaurant-gallery-photos'>
                    <div className={curImg?.picture ? 'picture official' : 'picture'}>
                      {curImg?.picture && !loading && (
                        <i style={{ left: tagPos?.x, top: tagPos?.y }} className='icon icon-official-tag'></i>
                      )}
                      {loading && <Loading />}
                      <img
                        className='photo media-image'
                        alt=''
                        onLoad={handleLoad}
                        key={curIndex}
                        src={(curImg?.image_url || curImg?.picture_url)?.split('?')[0] + '-gallery'}
                      />
                    </div>
                    <div className='meta'>
                      {curImg?.picture ? (
                        <div className='author'>
                          <span className='date'>{moment(curImg?.created_at).format('YYYY/MM/DD')}</span>
                        </div>
                      ) : (
                        <React.Fragment>
                          {curImg?.dish_name ? <span className='dish'>{curImg?.dish_name}</span> : null}
                          <div className='comment'>
                            {curImg?.comment_body ? <span className='comment'>{curImg?.comment_body}</span> : null}
                            <div className='comment-collapse'>
                              {showCollapse && !isOpen && <i className='icon gallery-down' onClick={togglePanel}></i>}
                            </div>
                          </div>

                          {curImg?.comment_body && (
                            <div className='comment-collapse viewFull'>
                              <strong className='toView' onClick={() => toViewDetail(curImg)}>
                                {t('WEB.View full review')} &gt;
                              </strong>
                              {isOpen && (
                                <div className='comment-collapse' onClick={togglePanel}>
                                  {t('WEB.Collapse')} <i className='icon gallery-top'></i>
                                </div>
                              )}
                            </div>
                          )}

                          <div className='author'>
                            <span className='member'>
                              {t('WEB.By')} {curImg?.from_member}
                            </span>
                            <span className='date'>{moment(curImg?.created_at).format('YYYY/MM/DD')}</span>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                  <button disabled={loading} type='button' className='restaurant-gallery-control gallery-control--next' onClick={nextPhoto}>
                    <i onClick={nextPhoto} className='icon icon-arrow-right'></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
